import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <>
      <div className="contact-container-top" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-4">
              <div className="contact-details">
                <h6 className="any-questions">Any questions regarding Reunion?</h6>
                <p>
                  <b>Contact: </b>IIT MAA
                </p>
                <p>
                  <b>Phone No: </b>+91 7397284362
                </p>
                <p>
                  <b>Email: </b>alumni@acr.iitm.ac.in
                </p><br/>
                <h6 className="any-questions">Any questions regarding Class gift?</h6>
                <p>
                  <b>Contact: </b>Ms Vidhya Janakiraman [ACR Office]
                </p>
                <p>
                  <b>Phone No: </b>+91 9940135383
                </p>
                <p>
                  <b>Email: </b>vidhya@ia.iitm.ac.in
                </p>
              </div>
            </div>
            <div className="col-8">
              <div className="reunion-coordination">
                <p>FROM YOUR REUNION BATCH COORDINATOR</p>
                <h1 className="right-heading-contact">
                  A message to the Class of 1994
                </h1>
                <p>
                  Can you believe it's been 30 years since we roamed the halls
                  of our beloved campus? I'm so excited to invite you all to our
                  long-overdue reunion! Let's get together on{" "}
                  <b>27th - 28th December, 2024</b> and relive those amazing
                  college days.
                  <br />
                </p>

                <p>
                  Let's reconnect, catch up, and make some new memories. And
                  while we're at it, let's give back to our alma mater. We had
                  some incredible opportunities here, and it would be fantastic
                  if we could help create those same chances for today's
                  students.
                  <br />I can't wait to see you all!
                </p>
                <p>
                  Warmly, <br />
                  Batch Coordinator
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tab-resp">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-2 mb-4">
              <div className="reunion-coordination">
                <p className="mobres-p1">FROM YOUR REUNION BATCH COORDINATOR</p>
                <h1 className="right-heading-contact">
                A message to the Class of 1994
                </h1>
                <p>
                Can you believe it's been 30 years since we roamed the halls
                  of our beloved campus? I'm so excited to invite you all to our
                  long-overdue reunion! Let's get together on <b>27th - 28th December, 2024</b> 
                  and relive those amazing college days.
                </p>
                <p>Let's reconnect, catch up, and make some new memories. And
                  while we're at it, let's give back to our alma mater. We had
                  some incredible opportunities here, and it would be fantastic
                  if we could help create those same chances for today's students.
                  <br />I can't wait to see you all!</p>
                <p>
                  Warmly, <br />
                  Batch Coordinator
                </p>
              </div>
            </div>
            <div className="col-md-12 mb-4 coordinat">
              <div className="contact-details">
              <h6 className="any-questions">Any questions regarding Reunion?</h6>
                <p>
                  <b>Contact: </b>IIT MAA
                </p>
                <p>
                  <b>Phone No: </b>+91 7397284362
                </p>
                <p>
                  <b>Email: </b>alumni@acr.iitm.ac.in
                </p>
                <h6 className="any-questions">Any questions regarding Class gift?</h6>
                <p>
                  <b>Contact: </b>Ms Vidhya Janakiraman [ACR Office]
                </p>
                <p>
                  <b>Phone No: </b>+91 9940135383
                </p>
                <p>
                  <b>Email: </b>vidhya@ia.iitm.ac.in
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-resp">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 mt-2 mb-3">
              <div className="reunion-coordination">
                <p className="mobres-p1">FROM YOUR REUNION BATCH COORDINATOR</p>
                <h1 className="right-heading-contact">
                A message to the Class of 1994
                </h1>
                <p>
                Can you believe it's been 30 years since we roamed the halls
                  of our beloved campus? I'm so excited to invite you all to our
                  long-overdue reunion! Let's get together on <b>27th - 28th December, 2024 </b> 
                  and relive those amazing college days.
                </p>
                <p>Let's reconnect, catch up, and make some new memories. And while we're at it, let's give back to our alma mater. We had some incredible opportunities here, and it would be fantastic if we could help create those same chances for today's students.</p>
                <p>
                I can't wait to see you all!
                </p>
                <p>
                  Warmly, <br />
                  Batch Coordinator
                </p>
              </div>
            </div>
            <div className="col-sm-12 mb-3">
              <div className="contact-details">
              <h6 className="any-questions">Any questions regarding Reunion?</h6>
                <p>
                  <b>Contact: </b>IIT MAA
                </p>
                <p>
                  {" "}
                  <b>Phone No: </b>+91 7397284362
                </p>
                <p>
                  {" "}
                  <b>Email: </b>alumni@acr.iitm.ac.in
                </p>
                <h6 className="any-questions">Any questions regarding Class gift?</h6>
                <p>
                  <b>Contact: </b>Ms Vidhya Janakiraman [ACR Office]
                </p>
                <p>
                  {" "}
                  <b>Phone No: </b>+91 9940135383
                </p>
                <p>
                  {" "}
                  <b>Email: </b>vidhya@ia.iitm.ac.in
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;
